// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3475":"styles-52974198","5859":"styles-5c03d38f","7240":"styles-e96e9bea"}[chunkId] + ".bundle.css";
};